<script setup>
import MainLayout from '@/layout/main/MainLayout.vue';
import InvoiceView from '@/components/orders/InvoiceView.vue';

defineOptions({
    layout: MainLayout,
});

defineProps({
    order: {
        type: Object,
        required: true
    },
    invoice: {
        type: Object,
        required: true
    },
    userType: {
        type: String,
        default: 'client'
    },
    invoiceSettings: {
        type: Object,
        required: true
    }
});
</script>

<template>
    <InvoiceView :order="order" :invoice="invoice" userType="client" :invoiceSettings="invoiceSettings" />
</template>
